import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
	setLoading,
	storeHeaderActions,
	storeSearchQuotation
} from 'store/reducers/mainSlice';
import QuickStatsBar from 'ui-component/QuickStatsBar';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import { FaPlus, FaSearch, FaUser } from 'react-icons/fa';
import Filter from 'ui-component/filter-menu/Filter';
import moment from 'moment';
import { Skeleton, Avatar } from '@mui/material';
import CurrencyValue from 'ui-component/CurrencyValue';
import toast from 'react-hot-toast';
import ExportListItemsModal from 'ui-component/ExportListItemsModal';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import usePermissions from 'hooks/usePermissions';
import ActionConfirmationModal from 'ui-component/confirmation-dialogs/actionConfirmationModal/ActionConfirmationModal';
import { PiInfoFill, PiMicrosoftExcelLogoFill } from 'react-icons/pi';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import { TbDatabaseExclamation } from 'react-icons/tb';
import { useQueryClient } from 'react-query';
import usePageTitle from 'hooks/usePageTitle';
import { FaChartBar } from 'react-icons/fa6';
import { MdKeyboardArrowDown } from 'react-icons/md';
import SortableHeader from 'ui-component/SortableHeader';
import { getCurrencySymbolV2, numberFormatter } from 'utils/currency';

import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import StatusBadge from 'ui-component/StatusBadge';
import useIsMobile from 'utils/isMobileUtils';
import ExportListItemsModalMobile from 'ui-component/ExportListItemsModalMobile';

const index = () => {
	const [setPageTitle] = usePageTitle('Quotations');
	// useEffect(() => {
	// 	return () => {
	// 		setPageTitle(null);
	// 	};
	// }, []);
	const history = useNavigate();
	const selectedCurrency = useSelector((state) => state.main.selectedCurrency);
	const [allPermissions, hasEveryPermission] = usePermissions();
	const [show, setShow] = useState('');
	const masterStatuses = useSelector((state) => state.main.masterStatuses);
	const statusTypes = useSelector((state) => state.main.statusTypes);
	const statusTypeList = statusTypes?.map((item) => ({ id: item.id, name: item.name }));
	const [activeComponent, setActiveComponent] = useState('Quotation');
	const dispatch = useDispatch();

	const [searchField, setSearchField] = useState();
	const [searchValue, setSearchValue] = useState();
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [filters, setFilters] = useState([]);
	const [activeFilters, setActiveFilters] = useState({});
	const [sortByFilter, setSortByFilter] = useState();
	const headerActions = useSelector((state) => state.main.headerActions);
	const [moduleName, setModuleName] = useState('');

	const location = useLocation();


	const storedSearch = useSelector((state) => state.main.searchQuotation);
	const storedFilter = useSelector((state) => state.main.filterQuotation);

	const [dataList, setDataList] = useState([]);
	// const [indexToDelete, setIndexToDelete] = useState(null);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const tableRef = useRef();
	const [showPreloadingRows, setShowPreloadingRows] = useState(true);
	const [totalRecords, setTotalRecords] = useState(0);


	const [isAllChecked, setIsAllChecked] = useState(false);
	const [checkedItems, setCheckedItems] = useState([]);
	const [showDeleteButton, setShowDeleteButton] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	


	useEffect(() => {
		// Only run fetchData after user stops typing (debounced by searchTimeout)
		// setIsLoading(true);
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const timeout = setTimeout(() => {
			const fetchData = async () => {
				if (storedSearch) {
					await handleSearch({ target: { value: storedSearch } });
				}
				setDataList([]);
				initializeData();
				getFiltersList();
			};
			fetchData();
		}, 500); // 500ms debounce

		setSearchTimeout(timeout);

		// Cleanup on unmount or before next effect run
		return () => clearTimeout(timeout);
		// Only trigger when these change
	}, [storedSearch, searchField, storedFilter]);

	useEffect(() => {
		setIsLoading(true);
	}, [activeFilters])
	useEffect(() => {
		const handleScroll = () => {
			if (!tableRef.current || showPreloadingRows || !hasMore) return;
			const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
			// Trigger only when user reaches the bottom (with a small threshold)
			if (scrollTop + clientHeight >= scrollHeight - 10) {
				loadMoreData();
			}
		};
		const currentRef = tableRef.current;
		if (currentRef) {
			currentRef.addEventListener('scroll', handleScroll);
		}
		return () => {
			if (currentRef) {
				currentRef.removeEventListener('scroll', handleScroll);
			}
		};
	}, [showPreloadingRows, hasMore, dataList]);


	const loadMoreData = () => {
		if (showPreloadingRows || !hasMore) return;
		setShowPreloadingRows(true);
		let request = {};
		request.page = page + 1;
		request.search = searchField?.length > 2 ? searchField : null;

		const currentActiveComponent = 2; // Quotation
		api.getQuotationInvoiceList(request, currentActiveComponent, activeFilters, searchField, sortByFilter).then((res) => {
			// Use pagination meta from backend
			const nextPage = res?.data?.data?.meta?.current_page || request.page;
			const lastPage = res?.data?.data?.meta?.last_page || nextPage;
			if (nextPage > lastPage || res?.data?.data?.data?.length === 0) {
				setHasMore(false);
			} else {
				setDataList(prev => [...prev, ...res?.data?.data?.data || []]);
				setPage(nextPage);
			}
			setShowPreloadingRows(false);
		});
	};


	const initializeData = () => {
		// Initial load
		let request = {}
		request.page = 1;
		request.search = searchField?.length > 2 ? searchField : null;
		
		const currentActiveComponent = 2; // Quotation
		api.getQuotationInvoiceList(request, currentActiveComponent, activeFilters, searchField, sortByFilter).then((res) => {
			
			setDataList([]);
			setTimeout(() => {
				setDataList(res?.data?.data?.data || []);

				setHasMore(true);
				setPage(1);
				dispatch(setLoading(false));
				setIsLoading(false);
				// setIsFirstLoad(false);
				setShowPreloadingRows(false);
				setTotalRecords(res?.data?.data?.total || 0);
			}, 300);
		});

	}

	const [selectedEstimate, setSelectedEstimate] = useState(null);

	const [paginationUrl, setPaginationUrl] = useState();

	const queryClient = useQueryClient();
	const [isLoading, setIsLoading] = useState(true);

	const [confirmationDialog, setConfirmationDialog] = useState({
		show: false,
		message: '',
		title: '',
		handleConfirm: () => { },
		handleClose: () => { }
	});

	const handleCloseConfirmationDialog = () => {
		setConfirmationDialog({
			show: false,
			message: '',
			title: '',
			handleConfirm: () => { },
			handleClose: () => { }
		});
	};

	const [showQuickStats, setShowQuickStats] = useState(false);
	const [quickStatsLoading, setQuickStatsLoading] = useState(false);
	const [quickStatsData, setQuickStatsData] = useState(null);
	const [isQuickStatsLoading, setIsQuickStatsLoading] = useState(true);

	useEffect(() => {
		if (showQuickStats && !quickStatsLoading) {
			setQuickStatsLoading(true);
			api
				.quickQuotationSummary(
					activeFilters,
					searchField?.length > 2 ? searchField : null,
					sortByFilter
				)
				.then((res) => {
                    setIsQuickStatsLoading(false);
					setQuickStatsData(res.data);
					setQuickStatsLoading(false);
				});
		}
	}, [showQuickStats]);

	const showConfirmationDialog = (
		title,
		message = '',
		onConfirm = () => { },
		onClose = () => {
			handleCloseConfirmationDialog();
		}
	) => {
		setConfirmationDialog({
			show: true,
			message: message,
			title: title,
			handleConfirm: onConfirm,
			handleClose: onClose
		});
	};


	const getFiltersList = () => {
		api.getEstimationFilter().then((res) => {
			setFilters(res.data);
		});
	};


	useEffect(() => {
		setModuleName('Quotations');
	}, []);

	useEffect(() => {
		setPaginationUrl(null);
		setShowQuickStats(false);
		dispatch(
			storeHeaderActions({
				showQuickStats: false,
				showExport: headerActions?.showExport
			})
		);
	}, [activeComponent, activeFilters, searchField, sortByFilter]);

	const invalidateQuery = () => {
		queryClient.invalidateQueries({ queryKey: ['salesorders', activeComponent, activeFilters, searchField, paginationUrl, sortByFilter] });
		queryClient.invalidateQueries({ queryKey: ['salesorder-counter'] });
		selectedEstimate && setSelectedEstimate(null);
	};

	useEffect(() => {
		queryClient.invalidateQueries({ queryKey: ['salesorder-counter'] });
	}, [activeComponent]);

	const handleClose = () => {
		setShow(null);
		setShowDeleteModal(false)
	}

	const handleDeleteDraft = (id) => {
		toast.promise(
			api.deleteDraft(id).then((res) => {
				if (res.status) {
					setShow('');
					invalidateQuery();
					setSelectedEstimate(null);
				}

				return res?.status ? res : abc;
			}),
			{
				loading: 'Deleting Draft...',
				success: (data) => `${data.message}`,
				error: <b>Failed to delete draft</b>
			}
		);
	};

	const handleCancelEstimate = (id) => {
		toast.promise(
			api.cancelEstimation(id).then((res) => {
				if (res.status) {
					setShow('');
					invalidateQuery();
					setSelectedEstimate(null);
				}

				return res?.status ? res : abc;
			}),
			{
				loading: 'Canceling Estimate...',
				success: (data) => `${data.message}`,
				error: <b>Failed to cancel estimate</b>
			}
		);
	};

	const viewDetails = (id) => {
		history(`${location.pathname}/${id}`);
	};


	const [exportCompIsLoading, setExportCompIsLoading] = useState(false);
	const [showExportModal, setShowExportModal] = useState(false);

	const exportListSubmitHandler = (selectedValues) => {
		setExportCompIsLoading(true);
		api.exportQuotation('', selectedValues, '', selectedCurrency).then((res) => {
			const newFileName = `Projectmix - Quotations`;
			if (res != 404) {
				var newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				saveAs(newBlob, `${newFileName}.xlsx`);
				// toast.dismiss(downloading);
				setExportCompIsLoading(false);
				toast.success('Downloaded Completed!');
				setShowExportModal(false);
				dispatch(
					storeHeaderActions({
						showQuickStats: headerActions?.showQuickStats,
						showExport: false
					})
				);
			} else {
				// toast.dismiss(downloading);
				setExportCompIsLoading(false);
				toast.error(res == 404 ? 'No Records Found!' : 'Download Failed!');
			}
		});
	};

	const handleSearch = (e) => {
		let text = e.target.value;
		
		setIsLoading(true);
		setSearchValue(text);
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		// Only update searchField after user stops typing for 500ms
		let timeout = setTimeout(() => {
			dispatch(storeSearchQuotation(text));
			setSearchField(text)	
		}, 500);

		setSearchTimeout(timeout);

	};

	useEffect(() => {
		if (headerActions?.showQuickStats) {
			setShowQuickStats(true);
		} else {
			setShowQuickStats(false);
		}

		if (headerActions?.showExport) {
			setShowExportModal(true);
		} else {
			setShowExportModal(false);
		}
	}, [headerActions]);

	const statusColorMap = {
		Draft: '#acacac', // gray
		Open: '#EBA562', // yellow
		Paid: '#00C13B', // green
		Canceled: '#E37560' // red
	};

	const isMobile = useIsMobile();


	const updateSortByStatus = (name) => {
		if (sortByFilter?.field == name) {
			setSortByFilter((e) => ({
				...e,
				direction: e?.direction == 'asc' ? 'desc' : 'asc'
			}));
		} else {
			setSortByFilter((e) => ({
				field: name,
				direction: 'asc'
			}));
		}
	};



	const handleCheckAll = () => {
		let updatedCheckedItems = [];
		let updatedCheckedItemsStatus = [];

		if (isAllChecked) {
			// Uncheck all
			setCheckedItems([]);
			setIsAllChecked(false);
		} else {
			// Check all
			updatedCheckedItems = dataList.map(item => item.id);
			setCheckedItems(updatedCheckedItems);
			setIsAllChecked(true);
		}
	};

	useEffect(() => {
		// Show delete button if there are any checked items
		setShowDeleteButton(checkedItems.length > 0);
	}, [checkedItems]);

	const handleCheckItem = (id) => {
		let updatedCheckedItems;

		if (checkedItems.includes(id)) {
			updatedCheckedItems = checkedItems.filter(itemId => itemId !== id);
			// Remove the status at the same index as the unchecked id
			const removeIndex = checkedItems.findIndex(itemId => itemId === id);
			setCheckedItems(updatedCheckedItems);
			setIsAllChecked(false);
		} else {
			updatedCheckedItems = [...checkedItems, id];
			setCheckedItems(updatedCheckedItems);
			if (updatedCheckedItems.length === dataList.length) setIsAllChecked(true);
		}

	};

	const handleDeleteMultipleRecords = () => {
		toast.promise(
			api.deleteMultipleQuotation({ checkedItems }).then((res) => {
				if (res.status) {
					setIsLoading(true);
					setDataList([]);
					initializeData();
					setIsAllChecked(false);
					setCheckedItems([]);
					setShowDeleteButton(false);
					setShowDeleteModal(false);
				}

				return res?.status ? res : abc;
			}),
			{
				loading: 'Deleting Records...',
				success: (data) => `${data.message}`,
				error: <b>Failed to delete records</b>
			}
		);
	}

	
	return (
		<>
			<div className="row">
				<div className="col-xl-12 col-lg-12">
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<h5 style={{ textAlign: 'center' }}>Quotations</h5>
							<div
								style={{
									paddingLeft: 20,
									paddingRight: 20,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									gap: 10,
									paddingBottom: 4
								}}
							>
								<PermissionAllowed permissions={['Create Estimation (Button)']}>
									<button
										className="btn btn-primary btn-outlined-main white-var"
										onClick={() => {
											history(`${location.pathname}/create`);
										}}
									>
										<FaPlus /> New
									</button>
								</PermissionAllowed>
								<button
									className="btn btn-primary btn-outlined-main white-var"
									style={{ minWidth: 'unset', paddingBlock: '4.1px' }}
									onClick={() => {
										setShowQuickStats(!showQuickStats);
									}}
								>
									<span style={{ fontSize: '1.1em' }}>
										<FaChartBar />
									</span>{' '}
									<span
										className="d-flex"
										style={{ transition: '0.3s ease-in-out', ...(showQuickStats ? { transform: 'rotate(180deg)' } : {}) }}
									>
										<MdKeyboardArrowDown />
									</span>
								</button>
								<PermissionAllowed permissions={['Export Estimation (Button)']}>
									<button
										className="btn btn-primary btn-outlined-main white-var "
										onClick={() => {
											setShowExportModal(true);
										}}
									>
										<PiMicrosoftExcelLogoFill style={{ fontSize: '1.4em' }} /> Export
									</button>
								</PermissionAllowed>
							</div>
						</div>
					</div>
					<div className="section-head-new pl-0 mar10201316 hide-on-mobile">
						<ul className="topListCom">
							<PermissionAllowed permissions={['Create Estimation (Button)']}>
								<button
									className="btn btn-primary btn-outlined-main-primary btn-create-report"
									onClick={() => {
										history(`${location.pathname}/create`);
									}}
								>
									<FaPlus /> New
								</button>
							</PermissionAllowed>
						</ul>
						<div className="actions d-none d-md-flex">
							<button
								className="btn btn-primary btn-outlined-main white-var"
								style={{ minWidth: 'unset', paddingBlock: '4.1px' }}
								onClick={() => {
									setShowQuickStats(!showQuickStats);
								}}
							>
								<span style={{ fontSize: '1.1em' }}>
									<FaChartBar />
								</span>{' '}
								<span
									className="d-flex"
									style={{ transition: '0.3s ease-in-out', ...(showQuickStats ? { transform: 'rotate(180deg)' } : {}) }}
								>
									<MdKeyboardArrowDown />
								</span>
							</button>
							<PermissionAllowed permissions={['Export Estimation (Button)']}>
							
								<button
									className="btn btn-primary btn-outlined-main white-var btn-create-report"
									onClick={() => {
										setShowExportModal(true);
									}}
								>
									<PiMicrosoftExcelLogoFill style={{ fontSize: '1.4em' }} /> Export
								</button>
							</PermissionAllowed>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							gap: 10,
							paddingTop: 0,
							paddingBottom: 5,
							paddingLeft: 20,
							paddingRight: 20
						}}
						className="show-on-mobile"
					>
						<form className="form-inline navbar-search" style={{ flex: 1 }}>
							<div style={{ position: 'relative', width: '100%' }}>
								<input
									type="text"
									className="form-control bg-white border"
									placeholder="Search"
									aria-label="Search"
									aria-describedby="basic-addon2"
									value={searchValue || ''}
									onChange={handleSearch}
									style={{ width: '100%', paddingRight: 36 }}
								/>
								<span
									className="searchIcon"
									style={{
										position: 'absolute',
										right: 10,
										top: '50%',
										transform: 'translateY(-50%)',
										color: '#888',
										pointerEvents: 'none'
									}}
								>
									<FaSearch />
								</span>
							</div>
						</form>
						<div style={{ flexShrink: 0 }}>
							<Filter
								activeFilters={activeFilters}
								onSubmit={setActiveFilters}
								filters={filters}
								multi={undefined}
								source={`quotation`}
							/>
						</div>
					</div>
					<div className={`card shadow-sm  bg-white mb-4 table-card ${isMobile ? 'admin-shorter-table' : ''}`}>
						<div className=" align-items-center justify-content-between TableSerachBar">
							<div>
								<Filter
									activeFilters={activeFilters}
									onSubmit={setActiveFilters}
									filters={filters}
									multi={undefined}
									source={'quotation'}
								/>
							</div>
							<form className="form-inline navbar-search" style={{ display: 'flex', gap: '5px' }} onSubmit={(e) => e.preventDefault()}>
								
								<div className="input-group">
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										value={searchValue || ''}
										onChange={handleSearch}
										style={{ width: '100%' }}
									/>
									<span className="searchIcon">
										<FaSearch />
									</span>
								</div>
							</form>
						</div>
						<div className="estimation-table-area">
							<div className="table-side">

								{
									!isMobile ? (
										<div
											className="table-responsive-xl tableData estimationList"
											ref={tableRef}
											style={{
												height: 'calc(100vh - 260px)',
												overflowY: 'auto',
												scrollbarWidth: 'thin',
												scrollbarColor: '#0966ff transparent'

											}}
										>
											{showQuickStats && (
												<div className="order-quick-stats">
													<div className="row w-100 m-0 p-0">
														<div className="col-12 col-md-6 m-0 p-0 mb-2 mb-md-none">
															<h5>
																Total Quotation
																<b>
																	<CurrencyValue
																		currencyObject={
																			quickStatsData?.accepted
																		}
																		defaultCurrency={
																			selectedCurrency.replace(/\s+/g, '') === 'all' ? 'usd' : selectedCurrency.replace(/\s+/g, '')
																		}
																	/>
																</b>
															</h5>
															<p className="hide-on-mobile">in current selection</p>
														</div>
													</div>
													<QuickStatsBar
														data={[
															{ name: 'Drafts', color: '#acacac', value: quickStatsData?.draft, count: quickStatsData?.accepted },
															{ name: 'Pending', color: '#ffc007', value: quickStatsData?.pending, count: quickStatsData?.accepted },
															{
																name: 'Accepted',
																color: '#3ac780',
																value: quickStatsData?.accepted,
																count: quickStatsData?.accepted
															},
															{
																name: 'Canceled',
																color: '#343a3e',
																value: quickStatsData?.canceled,
																count: quickStatsData?.accepted
															}
														]}
														isLoading={isQuickStatsLoading}
													/>
												</div>
											)}
											<table className="table  min-width-unset tbl-space pm-table d-none d-md-table">
												<thead>
													<tr className="sticky-header">
														<th scope="col" className="text-center align-middle" style={{ width: '50px' }}>
															<input 
																type="checkbox" 
																className="pm-checkbox"
																checked={isAllChecked}
																onChange={handleCheckAll}
															/>
														</th>
														<th scope="col" width="">
															<SortableHeader
																name={`estimation_number`}
																currentSortBy={sortByFilter}
																onClick={() => {
																	updateSortByStatus('estimation_number');
																}}
															>
																Reference
															</SortableHeader>
														</th>
														<th scope="col" width={''}>
															<SortableHeader
																name={`customer`}
																currentSortBy={sortByFilter}
																onClick={() => {
																	updateSortByStatus('customer');
																}}
															>
																Customer
															</SortableHeader>
														</th>

														<th scope="col" width="">
															<SortableHeader
																name="manager"
																currentSortBy={sortByFilter}
																onClick={() => {
																	updateSortByStatus('manager');
																}}
															>
																Manager
															</SortableHeader>
														</th>
														<th scope="col">
															<SortableHeader
																name="date"
																currentSortBy={sortByFilter}
																onClick={() => {
																	updateSortByStatus('date');
																}}
															>
																Date
															</SortableHeader>
														</th>
														<th scope="col" width={''}>
															<SortableHeader
																name="transit_company"
																currentSortBy={sortByFilter}
																onClick={() => {
																	updateSortByStatus('transit_company');
																}}
															>
																Transit
															</SortableHeader>
														</th>

														<th scope="col">
															<SortableHeader
																name="qty"
																currentSortBy={sortByFilter}
																onClick={() => {
																	updateSortByStatus('qty');
																}}
															>
																Qty
															</SortableHeader>
														</th>
														<th scope="col">
															<SortableHeader
																name="total"
																currentSortBy={sortByFilter}
																onClick={() => {
																	updateSortByStatus('total');
																}}
															>
																Total
															</SortableHeader>
														</th>
														<th scope="col" style={{ width: '110px' }}>
															<SortableHeader
																name="status"
																currentSortBy={sortByFilter}
																onClick={() => {
																	updateSortByStatus('status');
																}}
																style={{ maxWidth: '100px' }}
															>
																Status
															</SortableHeader>
														</th>
													</tr>
												</thead>
												<tbody>
													{isLoading ? (
														[...Array(50)].map((e, i) => (
															<tr style={{ height: '35px' }} key={i}>
																{[...Array(9)].map((e, i) => (
																	<td>
																		<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
																	</td>
																))}
															</tr>
														))
													) : (
														<>
															{dataList?.length > 0 && (
																dataList?.map((item, index) => {

																	const maxCharacters = 20;
																	const salesPersonFullName = `${item?.sales_person?.first_name || ''} ${item?.sales_person?.last_name || ''}`;
																	const truncatedSalesPersonFullName = salesPersonFullName && salesPersonFullName.length > maxCharacters ? salesPersonFullName.substring(0, maxCharacters) + '...' : salesPersonFullName;
																	return (
																		<tr style={{ background: `${checkedItems.includes(item.id) ? '#d9e7ff' : 'revert-layer'}` }} key={index}>
																			<td className="text-center align-middle">
																				<input
																					type="checkbox"
																					className="pm-checkbox"
																					checked={checkedItems.includes(item.id)}
																					onChange={() => {
																						if (item?.status !== 'Completed') {
																							handleCheckItem(item.id, item?.status)
																						}
																					}}
																				/>
																			</td>
																			<td
																				className={
																					hasEveryPermission(['View Estimation (Button)'])
																						? 'cursor-pointer align-middle font14'
																						: 'align-middle font14'
																				}
																				onClick={(e) => {
																					if (hasEveryPermission(['View Estimation (Button)'])) {
																						history(`${location.pathname}/${item?.id}?ref=${item?.ref}`);
																					}
																				}}
																			>
																				{item?.master_status?.name == 'Draft' ? (
																					<span style={{ fontStyle: 'italic', color: '#929598' }}>{item?.estimation_number}</span>
																				) : (
																					<span>{item?.estimation_number}</span>
																				)}
																			</td>
																			<td
																				className={
																					hasEveryPermission(['View Estimation (Button)'])
																						? 'cursor-pointer align-middle font14'
																						: 'align-middle font14'
																				}
																				onClick={(e) => {
																					if (hasEveryPermission(['View Estimation (Button)'])) {
																						history(`${location.pathname}/${item?.id}?ref=${item?.ref}`);
																					}
																				}}
																			>
																				<PrivacyModeContent>{item?.customer?.name}</PrivacyModeContent>
																			</td>
																			<td
																				className={
																					hasEveryPermission(['View Estimation (Button)'])
																						? 'cursor-pointer align-middle font14'
																						: 'align-middle font14'
																				}
																				onClick={(e) => {
																					if (hasEveryPermission(['View Estimation (Button)'])) {
																						history(`${location.pathname}/${item?.id}?ref=${item?.ref}`);
																					}
																				}}
																			>
																				{item?.sales_person?.first_name ? truncatedSalesPersonFullName : '-'}
																			</td>
																			<td
																				className={
																					hasEveryPermission(['View Estimation (Button)'])
																						? 'cursor-pointer align-middle font14'
																						: 'align-middle font14'
																				}
																				onClick={(e) => {
																					if (hasEveryPermission(['View Estimation (Button)'])) {
																						history(`${location.pathname}/${item?.id}?ref=${item?.ref}`);
																					}
																				}}
																			>
																				{`${moment(item?.start_date).format(CommonDateOnlyFormat)}`}
																			</td>
																			<td
																				onClick={(e) => {
																					history(`${location.pathname}/${item?.id}?ref=${item?.ref || ''}`);
																				}}
																				className="align-middle cursor-pointer"
																			>
																				<PrivacyModeContent notUserRestricted>
																					{item?.transit_company?.name
																						? item?.transit_company?.name && item.transit_company?.name.length > 20
																							? item.transit_company?.name.substring(0, 20) + '...'
																							: item?.transit_company?.name
																						: '-'}
																				</PrivacyModeContent>
																			</td>
																			<td
																				className={
																					hasEveryPermission(['View Estimation (Button)'])
																						? 'cursor-pointer align-middle font14'
																						: 'align-middle font14'
																				}
																				onClick={(e) => {
																					if (hasEveryPermission(['View Estimation (Button)'])) {
																						history(`${location.pathname}/${item?.id}?ref=${item?.ref}`);
																					}
																				}}
																			>
																				{item?.item_qty?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}
																			</td>
																			<td
																				className={
																					hasEveryPermission(['View Estimation (Button)'])
																						? 'cursor-pointer align-middle font14'
																						: 'align-middle font14'
																				}
																				onClick={(e) => {
																					if (hasEveryPermission(['View Estimation (Button)'])) {
																						history(`${location.pathname}/${item?.id}?ref=${item?.ref}`);
																					}
																				}}
																			>
																				<div className="flex gap-1">
																					<div style={{ marginTop: `${selectedCurrency === 'aed' ? '-1px' : '0' }`}}>
																						{getCurrencySymbolV2(selectedCurrency, item?.currency, '11px', '11px')}
																					</div>
																					<div>
																						{item?.converted_currency_total ? numberFormatter.format(item?.converted_currency_total[selectedCurrency === 'all' ? item?.currency : selectedCurrency]) : 'N/A'}
																					</div>
																				</div>
																				
																			</td>
																			<td
																				style={{ width: '110px' }}
																				className={
																					hasEveryPermission(['View Estimation (Button)'])
																						? 'cursor-pointer align-middle font14'
																						: 'align-middle font14'
																				}
																				onClick={(e) => {
																					if (hasEveryPermission(['View Estimation (Button)'])) {
																						history(`${location.pathname}/${item?.id}?ref=${item?.ref}`);
																					}
																				}}
																			>
																				<StatusBadge itemStatus={item?.master_status?.name} />
																			</td>
																		</tr>
																	);
																})
															)}
															{showPreloadingRows && (
																[...Array(100)].map((e, i) => (
																	<tr style={{ height: '35px' }} key={i}>
																		{[...Array(9)].map((e, i) => (
																			<td>
																				<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
																			</td>
																		))}
																	</tr>
																))
															)}
															{(dataList?.length < 1 && !isLoading) && (
																<tr className="no-hover">
																	<td colSpan={9}>
																		<div className="not-found-container">
																			<div className="not-found-icon">
																				<img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
																			</div>
																			<h6 className="not-found-text">No Data Available</h6>
																			<Link to={'/sales/quotations/create'} className="btn btn-primary btn-outlined-main">
																				Create new quotation ?
																			</Link>
																		</div>
																	</td>
																</tr>
															)}
														</>
													)}
												</tbody>
											</table>
										</div>
									) : (
										<div
											className="table-responsive-xl tableData estimationList"
											ref={tableRef}
											style={{
												height: `calc(100dvh - ${Object.keys(activeFilters).length === 0 ? '305px' : '332px' })`,
												overflowY: 'auto',
												display: 'flex',
												flexDirection: 'column'
											}}
										>
										
												
											{isLoading ? (
												<div className="inv-cards-list d-md-none">
													{[...Array(15)].map((_, idx) => (
														<div
															key={idx}
															className="order-list-card"
															style={{
																background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
																marginBottom: 10,
																borderRadius: 12,
																padding: 16,
																minHeight: 90,
																display: 'flex',
																flexDirection: 'column',
																gap: 10
															}}
														>
															{[...Array(3)].map((__, i) => (
																<div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
																	<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
																</div>
															))}
														</div>
													))}
												</div>
											) : (
												<>
													{showQuickStats && (
														<div className="order-quick-stats">
															<div className="row w-100 m-0 p-0">
																<div className="col-12 col-md-6 m-0 p-0 mb-2 mb-md-none">
																	<h5>
																		Total Quotation
																		{' '}
																		<b>
																			<CurrencyValue
																				currencyObject={
																					quickStatsData?.total_value
																				}
																				defaultCurrency={
																					selectedCurrency.replace(/\s+/g, '') === 'all' ? 'usd' : selectedCurrency.replace(/\s+/g, '')
																				}
																			/>
																		</b>
																	</h5>
																	<p className="hide-on-mobile">in current selection</p>
																</div>
																<div className="col-12 col-md-6 m-0 p-0">
																	<h5>
																		To receive{' '}
																		<b>
																			<CurrencyValue
																				currencyObject={quickStatsData?.accepted}
																				defaultCurrency={
																					selectedCurrency.replace(/\s+/g, '') === 'all' ? 'usd' : selectedCurrency.replace(/\s+/g, '')
																				}
																			/>
																		</b>
																	</h5>
																	<p className="hide-on-mobile">in current selection</p>
																</div>
															</div>
															<QuickStatsBar
																data={[
																	{ name: 'Drafts', color: '#acacac', value: quickStatsData?.draft, count: quickStatsData?.accepted },
																	{ name: 'Pending', color: '#ffc007', value: quickStatsData?.pending, count: quickStatsData?.accepted },
																	{
																		name: 'Accepted',
																		color: '#3ac780',
																		value: quickStatsData?.accepted,
																		count: quickStatsData?.accepted
																	},
																	{
																		name: 'Canceled',
																		color: '#343a3e',
																		value: quickStatsData?.canceled,
																		count: quickStatsData?.accepted
																	}
																]}
																isLoading={isQuickStatsLoading}
															/>
														</div>
													)}

													<div className="inv-cards-list d-md-none">
														{dataList?.map((item, index) => (
															<div
																className="order-list-card active-action"
																style={{
																	background: index % 2 === 0 ? '#f9f9f9' : '#fff'
																}}
																onClick={() => viewDetails(item?.id)}
															>
																<div className="order-list-card-header">
																	<h6 className="order-no">

																		{item?.master_status?.name == 'Draft' ? (
																			<span style={{ fontStyle: 'italic', color: '#929598' }}>{item?.estimation_number}</span>
																		) : (
																			<span>{item?.estimation_number}</span>
																		)}
																	</h6>
																	<p className="order-date">{moment(item?.start_date).format(CommonDateOnlyFormat)}</p>
																</div>

																<div className="order-list-card-body">
																	<div className="order-contacts">
																		<p className="order-customer">
																			<PrivacyModeContent>{item?.customer?.name}</PrivacyModeContent>
																		</p>
																		{item?.transit_company && (
																			<p className="order-transit">
																				via{' '}
																				<PrivacyModeContent notUserRestricted>
																					{item?.transit_company?.name
																						? item?.transit_company?.name && item.transit_company?.name.length > 20
																							? item.transit_company?.name.substring(0, 20) + '...'
																							: item?.transit_company?.name
																						: '-'}
																				</PrivacyModeContent>
																			</p>
																		)}
																	</div>
																	<p className="total-val" style={{ color: statusColorMap[item?.master_status?.name] || '#acacac' }}>
																		<div className="flex gap-1">
																			<div style={{ marginTop: `${selectedCurrency === 'aed' ? '-1px' : '0' }`}}>
																				{getCurrencySymbolV2(selectedCurrency, item?.currency, '11px', '11px')}
																			</div>
																			<div>
																				{item?.converted_currency_total ? numberFormatter.format(item?.converted_currency_total[selectedCurrency === 'all' ? item?.currency : selectedCurrency]) : 'N/A'}
																			</div>
																		</div>
																	</p>
																</div>

																<div className="order-list-card-footer">
																	<div className="order-icon-items">
																		{item?.master_status?.name != 'Credit Note' && !item?.is_credit_note && (
																			<div
																				className="order-icon-item order-manager"
																				style={{ color: statusColorMap[item?.master_status?.name] || '#acacac' }}
																			>
																				<div className="icons-span hide-on-mobile">
																					<Avatar sx={{ width: 20, height: 20 }} style={{ fontSize: 10 }} src={item?.sales_person?.user_profile}>
																						{item?.sales_person?.first_name?.split(' ')?.[0]?.slice(0, 1)}
																						{item?.sales_person?.last_name?.split(' ')?.[1]?.slice(0, 1)}
																					</Avatar>
																				</div>
																				<div className="show-on-mobile">
																					<FaUser />
																				</div>
																				<div>
																					{item?.sales_person?.first_name
																						? `${item?.sales_person?.first_name} ${item?.sales_person?.last_name}`
																						: '-'}
																				</div>
																			</div>
																		)}
																		{item?.master_status?.name != 'Draft' &&
																			item?.master_status?.name != 'Estimated' &&
																			item?.master_status?.name != 'Pending Manager' &&
																			// item?.master_status?.name != 'Pending Customer' &&
																			item?.master_status?.name != 'Pending' &&
																			item?.master_status?.name != 'Credit Note' &&
																			item?.master_status?.name != 'Cancelled' && (
																				<div
																					className={`order-icon-item  ${
																						(item?.paid_status === 'Paid' || item?.master_status?.name === 'Accepted')
																							? 'order-paid'
																							: item?.paid_status == 'Partial'
																							? 'order-partial-paid'
																							: 'order-unpaid'
																					}`}
																				>
																					<span>{item?.paid_status}</span>
																				</div>
																			)}
																	</div>

																	<div
																		className={`order-status order-status-${item?.master_status?.name
																			?.toLowerCase()
																			?.replaceAll(' ', '-')} hide-on-mobile`}
																	>
																		{item?.master_status?.name}
																	</div>
																	<div className="order-icon-items show-on-mobile">
																		<div className="order-icon-item order-manager">
																			<div
																				className="order-circle"
																				style={{
																					background: statusColorMap[item?.master_status?.name] || '#acacac', // fallback to gray
																					width: 10,
																					height: 10,
																					borderRadius: '50%',
																					display: 'inline-block'
																				}}
																			></div>
																			<div style={{ color: statusColorMap[item?.master_status?.name] || '#acacac' }}>
																				{item?.master_status?.name}
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														))}
														{showPreloadingRows && (
															[...Array(100)].map((_, idx) => (
																<div
																	key={idx}
																	className="order-list-card"
																	style={{
																		background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
																		marginBottom: 10,
																		borderRadius: 12,
																		padding: 16,
																		minHeight: 90,
																		display: 'flex',
																		flexDirection: 'column',
																		gap: 10
																	}}
																>
																	{[...Array(3)].map((__, i) => (
																		<div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
																			<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
																		</div>
																	))}
																</div>
															))
														)}
														
														{(dataList?.length < 1 && !isLoading) && (
															<div className="w-100">
																<div className="not-found-container">
																	<div className="not-found-icon">
																		<TbDatabaseExclamation />
																	</div>
																	<h6 className="not-found-text">No Data Available</h6>

																	<Link to={'/sales/quotation/create'} className="btn btn-primary btn-outlined-main">
																		Create new Quotation ?
																	</Link>
																</div>
															</div>
														)}
													</div>
												</>
											)}
										</div>
									)
								}
								{isLoading ? (
									<div className="inv-cards-list d-md-none" style={{ padding: '12px 0' }}>
										{[...Array(15)].map((_, idx) => (
											<div
												key={idx}
												className="order-list-card"
												style={{
													background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
													marginBottom: 10,
													borderRadius: 12,
													padding: 16,
													minHeight: 90,
													display: 'flex',
													flexDirection: 'column',
													gap: 10
												}}
											>
												{[...Array(3)].map((__, i) => (
													<div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
														<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
													</div>
												))}
											</div>
										))}
									</div>
								) : (
									''
								)}
								<div
									className="hide-on-mobile"
									style={{
										padding: '10px 0 0 20px',
										borderTop: '1px solid #e0e0e0e0',
										display: 'flex',
										gap: '5px',
										justifyContent: 'space-between',
										height: '40px',
									}}
								>

									<div className="flex align-items-center" style={{ gap: '10px' }}>
										{
											showDeleteButton && (
												<>
													<button 
														className="btn btn-danger btn-outlined-main-danger white-va"
														onClick={() => {
															setShowDeleteModal(true);
														}}
													>
														Delete
													</button>
													<div>
														<span className="text-gray-800">Selected:</span>{' '}
														<span className="fw-500">
															{checkedItems.length ? checkedItems.length.toLocaleString('en-US') : 0}
														</span>
													</div>
												</>
											)
										}
									</div>
									<div className="flex align-items-center ml-auto" style={{ gap: '5px', paddingRight: '25px' }}>
										<div className="text-gray-800">Total Record:</div>
										<div className="fw-500">
											{isLoading ? (
												<div style={{ width: '100px' }}>
													<Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
												</div>
											) : (
												totalRecords.toLocaleString('en-US')
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{confirmationDialog?.show && (
				<ActionConfirmationModal
					show={confirmationDialog?.show}
					message={confirmationDialog?.message}
					title={confirmationDialog?.title}
					customConfirmText={confirmationDialog?.customConfirm || 'Confirm'}
					customCancelText={confirmationDialog?.customCancel || 'Cancel'}
					customIcon={<PiInfoFill />}
					handleConfirm={confirmationDialog?.handleConfirm}
					handleClose={confirmationDialog?.handleClose}
				/>
			)}

			{show && (
				<DeleteConfirmation
					show={show}
					handleClose={handleClose}
					customDeleteButtonText={show?.master_status?.name == 'Estimated' ? 'Confirm' : 'Delete'}
					handleDelete={() => {
						if (
							show.master_status?.name == 'Estimated' ||
							show.master_status?.name == 'Pending Manager' ||
							show.master_status?.name == 'Pending'
						) {
							handleCancelEstimate(show?.id);
						} else {
							handleDeleteDraft(show?.id);
						}
					}}
					title={
						show.master_status?.name == 'Estimated' ||
						show.master_status?.name == 'Pending Manager' ||
						show.master_status?.name == 'Pending'
							? 'Confirm Cancel'
							: 'Confirm Delete'
					}
					message={
						show.master_status?.name == 'Estimated' ||
						show.master_status?.name == 'Pending Manager' ||
						show.master_status?.name == 'Pending'
							? `Are you sure you want to cancel estimate ${show.estimation_number}`
							: `Are you sure you want to delete ${show.draft_number || show.estimation_number}`
					}
				/>
			)}

			{showExportModal && !isMobile && (
				<ExportListItemsModal
					openpopup={true}
					disablepopup={() => {
						setShowExportModal(false);
						dispatch(
							storeHeaderActions({
								showQuickStats: headerActions?.showQuickStats,
								showExport: false
							})
						);
					}}
					filters={filters}
					moduleName={'Orders'}
					onSubmit={exportListSubmitHandler}
					historyApi={api.getExportsHistory('orders')}
					isLoading={exportCompIsLoading}
					exportHistoryPerms={['Show Estimation Export History (Button)']}
				/>
			)}

			{showExportModal && isMobile && (
				<ExportListItemsModalMobile
					openpopup={true}
					disablepopup={() => {
						setShowExportModal(false);
						dispatch(
							storeHeaderActions({
								showQuickStats: headerActions?.showQuickStats,
								showExport: false
							})
						);
					}}
					filters={filters}
					moduleName={'Orders'}
					onSubmit={exportListSubmitHandler}
					historyApi={api.getExportsHistory('orders')}
					isLoading={exportCompIsLoading}
					exportHistoryPerms={['Show Estimation Export History (Button)']}
				/>
			)}

			{showDeleteModal && (
				<DeleteConfirmation
					show={showDeleteModal}
					handleClose={handleClose}
					customDeleteButtonText={`Delete`}
					handleDelete={handleDeleteMultipleRecords}
					title={`Confirmation`}
					message={`Are you sure you want to delete ${checkedItems.length} selected records from quotations?`}
				/>
			)}
		</>
	);
};

export default index;
